import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const QuestionMark: React.FC<CardGradientProps> = ({
  className,
  width = "14",
  height = "21",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 14 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.95675 11.9135C9.69428 11.9135 11.9135 9.69428 11.9135 6.95675C11.9135 4.21921 9.69428 2 6.95675 2C4.21921 2 2 4.21921 2 6.95675"
        stroke="#FFA686"
        stroke-width="3.71756"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.95654 11.9136V14.392"
        stroke="#CFB2FF"
        stroke-width="3.71756"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="6.95667" cy="18.9356" r="2.06531" fill="#CFB2FF" />
    </svg>
  );
};

export default QuestionMark;
